export default __webpack_public_path__ + "static/media/home-design-agency-img-03.9e568cbb.jpg";